module.exports = __webpack_public_path__ + "img/half-banner.ce71b28.png";